export default class requirementModel {
    constructor({id, id_career, id_requirement, positions, requirement, is_active, created_by_name}) {
        this.id = id;
        this.id_career = id_career;
        this.id_requirement = id_requirement;
        this.positions = positions;
        this.requirement = requirement;
        this.status = is_active;
        this.created_by_name = created_by_name;
    }
}